/**
 * Class for sprite atlas handling.
 * @class SpriteAtlas
 * @extends RawAsset
 * @constructor
 */
var SpriteAtlas = cc.Class({
    name: 'cc.SpriteAtlas',
    extends: cc.Asset,
});

cc.SpriteAtlas = SpriteAtlas;
module.exports =  SpriteAtlas;
